import { PrescripcionComponent } from './prescripcion/prescripcion.component';
import { EdicionCargoComponent } from './edicion-cargo/edicion-cargo.component';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ComponentesRoutingModule } from "./componentes-routing.module";

// import { PdfViewerModule } from "ng2-pdf-viewer";
//import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
   
//<<PrimeNG>>
import { DropdownModule } from "primeng/dropdown";
import { SliderModule } from 'primeng/slider';
import { RadioButtonModule } from "primeng/radiobutton";
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from "primeng/inputtext";
import { CardModule } from "primeng/card";
import { ButtonModule } from "primeng/button";
import { ListboxModule } from "primeng/listbox";
import { PickListModule } from "primeng/picklist";
import { VirtualScrollerModule } from "primeng/virtualscroller";
import { MenuModule } from "primeng/menu";
import { TableModule } from "primeng/table";
import { MultiSelectModule } from "primeng/multiselect";
import { MenubarModule } from "primeng/menubar";
import { TabViewModule } from "primeng/tabview";
import { InputMaskModule } from "primeng/inputmask";
import { CheckboxModule } from "primeng/checkbox";
import { TooltipModule } from "primeng/tooltip";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { ProgressBarModule } from 'primeng/progressbar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessagesModule } from 'primeng/messages';
import { MessageService } from 'primeng/api';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { CalendarModule } from 'primeng/calendar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';
import {FileUploadModule} from 'primeng/fileupload';
import { SelectButtonModule } from 'primeng/selectbutton';
import { GalleriaModule } from 'primeng/galleria';

// <<Componentes>> 
import { PersonaClientesComponent } from "../componentes/persona-clientes/persona-clientes.component";
import { AguaBuscaCuentasComponent } from "../componentes/agua-busca-cuentas/agua-busca-cuentas.component";
import { AguasComponent } from "../componentes/aguas/aguas.component";
import { PersonasComponent } from "../componentes/personas/personas.component";
import { MedidoresComponent } from "../componentes/medidores/medidores.component";
import { CargosDetallesComponent } from "../componentes/cargos-detalles/cargos-detalles.component";
import { BuscaTramiteComponent } from "../componentes/busca-tramite/busca-tramite.component";
import { CatConceptosComponent } from "../componentes/cat-conceptos/cat-conceptos.component";
import { CertificadoNoAdeudoComponent } from "./../componentes/certificado-no-adeudo/certificado-no-adeudo.component";
import { MonitoreoFlujoTramiteComponent } from "../componentes/monitoreo-flujo-tramite/monitoreo-flujo-tramite.component";
import { VisorComponent } from "../componentes/visor/visor.component";
import { BuscaDetalleSolicitudComponent } from "../componentes/busca-detalle-solicitud/busca-detalle-solicitud.component";
import { InfoTramiteComponent } from "../componentes/info-tramite/info-tramite.component";
import { CmpFacturacionComponent } from "../componentes/cmp-facturacion/cmp-facturacion.component";
import { MedioPagosComponent } from "../componentes/medio-pagos/medio-pagos.component";
import { CobrosAguaComponent } from "../componentes/cobros-agua/cobros-agua.component";
import { CajaServiciosComponent } from "../componentes/caja-servicios/caja-servicios.component";
import { CortesComponent } from "./cortes/cortes.component";
import { EstadoCuentaInformacionComponent } from "./estado-cuenta-informacion/estado-cuenta-informacion.component";
import { BuscaCobrosComponent } from "./busca-cobros/busca-cobros.component";
import { NgxCurrencyModule } from "ngx-currency";
import { DatosCartowebComponent } from "../componentes/datos-cartoweb/datos-cartoweb.component";
import { CortesAperturaComponent } from "../componentes/cortes-apertura/cortes-apertura.component";
import { DatosFacturacionCajaComponent } from "./datos-facturacion-caja/datos-facturacion-caja.component";
import { CancelaCobrosComponent } from "./cancela-cobros/cancela-cobros.component";
import { ConsultaLecturasComponent } from "../componentes/consulta-lecturas/consulta-lecturas.component";
import { EjecucionFiscalInformacionComponent } from "./ejecucion-fiscal-informacion/ejecucion-fiscal-informacion.component";
import { GeneraRutasComponent } from "../componentes/genera-rutas/genera-rutas.component";
import { ConsumosRowComponent } from "./consumos-row/consumos-row.component";
import { ConsumosGridComponent } from "./consumos-grid/consumos-grid.component";
import { CatColoniasComponent } from "./cat-colonias/cat-colonias.component";
import { ObtenerUsuarioPorCargoComponent } from "./obtener-usuario-por-cargo/obtener-usuario-por-cargo.component";
import { CatMunicipiosComponent } from "./cat-municipios/cat-municipios.component";
import { CatMunicipiosGridComponent } from "./cat-municipios-grid/cat-municipios-grid.component";
import { VencimientosLecturaComponent } from "./vencimientos-lectura/vencimientos-lectura.component";
import { PadronAguaGeneralesComponent } from "./padron-agua-generales/padron-agua-generales.component";
import { CatDescuentosComponent } from "./cat-descuentos/cat-descuentos.component";
import { CatTipoServiciosGridComponent } from './cat-tipo-servicios-grid/cat-tipo-servicios-grid.component';
import { CatAguaZonasGridComponent } from './cat-agua-zonas-grid/cat-agua-zonas-grid.component';

import { CatGrupoConceptosGridComponent } from './cat-grupo-conceptos-grid/cat-grupo-conceptos-grid.component';
import { CatDireccionesGridComponent } from './cat-direcciones-grid/cat-direcciones-grid.component';
import { CatDepartamentosGridComponent } from './cat-departamentos-grid/cat-departamentos-grid.component';
import { CatConceptosGridComponent } from './cat-conceptos-grid/cat-conceptos-grid.component';
// import { CatTipoDocumentosComponent } from './cat-tipo-documentos/cat-tipo-documentos.component';
import { CatAnomalias } from '../entidades/entidades';
import { CatAnomaliasGridComponent } from './cat-anomalias-grid/cat-anomalias-grid.component';
import { CatUsuariosGridComponent } from './cat-usuarios-grid/cat-usuarios-grid.component';
import { CatSucursalesGridComponent } from './cat-sucursales-grid/cat-sucursales-grid.component';
import { CatCalendarioGridComponent } from "./cat-calendario-grid/cat-calendario-grid.component";
import { CatEstatusGridComponent } from './cat-estatus-grid/cat-estatus-grid.component';
import { CatVencimientos_GridComponent } from './cat-vencimientos-grid/cat-vencimientos-grid.component';
import { CatTipoTomasGridComponent } from './cat-tipo-tomas-grid/cat-tipo-tomas-grid.component';
import { CatTipoDocumentosGridComponent } from "./cat-tipo-documentos-grid/cat-tipo-documentos-grid.component";
import { CatTipoIngresoGridComponent } from './cat-tipo-ingreso-grid/cat-tipo-ingreso-grid.component';
import { CatTipoPeriodosGridComponent } from './cat-tipo-periodos-grid/cat-tipo-periodos-grid.component';
import { CatTipoLevantamientosGridComponent } from "./cat-tipo-levantamientos-grid/cat-tipo-levantamientos-grid-component";
import { CatTipoPersonasGridComponent } from './cat-tipo-personas-grid/cat-tipo-personas-grid.component';
import { CatUnidadMedidasGridComponent } from "./cat-unidad-medidas-grid/cat-unidad-medidas-grid.component";
import { CatUnidadCobrosGridComponent } from './cat-unidad-cobros-grid/cat-unidad-cobros-grid.component';
import { CatUbicacionMedidoresGridComponent } from './cat-ubicacion-medidores-grid/cat-ubicacion-medidores-grid.component';
import { CatAtributoInmueblesGridComponent } from './cat-atributo-inmuebles-grid/cat-atributo-inmuebles-grid.component';
import { CatCategoriaAtributosGridComponent } from './cat-categoria-atributos-grid/cat-categoria-atributos-grid.component';
import { CatCfdiUsosGridComponent } from './cat-cfdi-usos-grid/cat-cfdi-usos-grid.component';
import { CatCargosGridComponent } from './cat-cargos-grid/cat-cargos-grid.component';
import { CatConceptoCostosGridComponent } from './cat-concepto-costos-grid/cat-concepto-costos-grid.component';
import { CatConsumoTarifasGridComponent } from './cat-consumo-tarifas-grid/cat-consumo-tarifas-grid.component';
import { CatDiametroTomasGridComponent } from './cat-diametro-tomas-grid/cat-diametro-tomas-grid.component';
import { CatEtapasTramitesGridComponent } from './cat-etapas-tramites-grid/cat-etapas-tramites-grid.component';
import { CatFundamentosLegalesGridComponent } from './cat-fundamentos-legales-grid/cat-fundamentos-legales-grid.component';
import { CatInpcsGridComponent } from './cat-inpcs-grid/cat-inpcs-grid.component';
import { CatMarcaMedidoresGridComponent } from './cat-marca-medidores-grid/cat-marca-medidores-grid.component';
import { CatMedioPagosGridComponent } from './cat-medio-pagos-grid/cat-medio-pagos-grid.component';
import { CatMotivoLevantamientosGridComponent } from './cat-motivo-levantamientos-grid/cat-motivo-levantamientos-grid.component';
import { CatParametroGruposGridComponent } from './cat-parametro-grupos-grid/cat-parametro-grupos-grid.component';
import { CatRequisitosGridComponent } from './cat-requisitos-grid/cat-requisitos-grid.component';
import { CatRolesGridComponent } from './cat-roles-grid/cat-roles-grid.component';
import { CatTipoBloqueosGridComponent } from './cat-tipo-bloqueos-grid/cat-tipo-bloqueos-grid.component';
import { CatTipoComprobantesGridComponent } from './cat-tipo-comprobantes-grid/cat-tipo-comprobantes-grid.component';
import { CatTipoConsumosGridComponent } from './cat-tipo-consumos-grid/cat-tipo-consumos-grid.component';
import { CatTipoContratoPersonasGridComponent } from './cat-tipo-contrato-personas-grid/cat-tipo-contrato-personas-grid.component';
import { CatTipoGirosGridComponent } from './cat-tipo-giros-grid/cat-tipo-giros-grid.component';
import { CatTipoMedidoresGridComponent } from './cat-tipo-medidores-grid/cat-tipo-medidores-grid.component';
import { CatTipoUsosGridComponent } from './cat-tipo-usos-grid/cat-tipo-usos-grid.component';
import { CatBancosGridComponent } from './cat-bancos-grid/cat-bancos-grid.component';
import { CatEstadoFuncionamientosGridComponent } from './cat-estado-funcionamientos-grid/cat-estado-funcionamientos-grid.component';
import { CatEstadosGridComponent } from './cat-estados-grid/cat-estados-grid.component';
import { CatCallesGridComponent } from './cat-calles-grid/cat-calles-grid.component';
import { CatMotivoCancelacionesGridComponent } from './cat-motivo-cancelaciones-grid/cat-motivo-cancelaciones-grid.component';
import { AguaBloqueosComponent } from './agua-bloqueos/agua-bloqueos.component';
import { AguaDescuentosComponent } from './agua-descuentos/agua-descuentos.component';
import { EnviarCorreoComponent } from './enviar-correo/enviar-correo.component';
import { SolicitudDetallesGridComponent } from './solicitud-detalles-grid/solicitud-detalles-grid.component';
import { CatModulosGridComponent } from './cat-modulos-grid/cat-modulos-grid.component';
import { CatNivelSeguridadesGridComponent } from './cat-nivel-seguridades-grid/cat-nivel-seguridades-grid.component';
import { PrivilegiosGridComponent } from './privilegios-grid/privilegios-grid.component';
import { MedidoresGridComponent } from './medidores-grid/medidores-grid.component';
import { AguaBuscaCuentasGridComponent } from './agua-busca-cuentas-grid/agua-busca-cuentas-grid.component';
import { BajaDeCuentaComponent } from './baja-de-cuenta/baja-de-cuenta.component';
import { AltaMedidoresComponent } from './alta-medidores/alta-medidores.component';
import { RConceptosEtapasTramitesGridComponent } from '../componentes/rconceptos-etapas-tramites-grid/rconceptos-etapas-tramites-grid.component';
import { EstadoCuentaComponent } from './estado-cuenta/estado-cuenta.component';
import { EstadocuentamasivoComponent } from './estadocuentamasivo/estadocuentamasivo.component';
import { VentanillaComponent } from '../componentes/ventanilla/ventanilla.component';
import { InformacionComponent } from "./informacion/informacion.component";
import { ProrrateosComponent} from '../componentes/prorrateos-grid/prorrateos-component';

import { PrivilegiosARolesComponent } from "./privilegios-a-roles/privilegios-a-roles.component";
import { RUsuarioNivelesGridComponent } from './rusuario-niveles-grid/rusuario-niveles-grid.component';
import { CapturaLecturaRutasComponent } from "./captura-lectura-rutas/captura-lectura-rutas.component";
import { CorrecionLecturasComponent } from './correcion-lecturas/correcion-lecturas.component';
import { SimuladorLecturasComponent } from './simulador-lecturas/simulador-lecturas.component';
import { RolesAUsuariosComponent } from "./roles-a-usuarios/roles-a-usuarios.component";
import { EstadoCuentaOnlineComponent } from './estado-cuenta-online/estado-cuenta-online.component';
import { AguaBuscaCuentaOnlineComponent } from "./agua-busca-cuenta-online/agua-busca-cuenta-online.component";
import { EstadoCuentaInformacionOnlineComponent } from './estado-cuenta-informacion-online/estado-cuenta-informacion-online.component';
import { CargosDetallesOnlineComponent } from './cargos-detalles-online/cargos-detalles-online.component';
import { ManualesComponent } from '../componentes/manuales/manuales.component';
import { ConciliacionComponent} from '../componentes/conciliacion/conciliacion.component';
import { BuscaBitacoraGridComponent } from './busca-bitacora-grid/busca-bitacora-grid.component';
import { ConsultaBitacoraGridComponent } from "../componentes/consulta-bitacora-grid/consulta-bitacora-grid.component";
import { ConsultaHistoricoMigradoGridComponent } from './consulta-historico-migrado-grid/consulta-historico-migrado-grid.component';
import { ConsultaHistoricoMovimientosGridComponent} from './consulta-historico-movimientos-grid/consulta-historico-movimientos-grid.component';
import { EstadocuentamasivoCapturaComponent } from './estadocuentamasivo-captura/estadocuentamasivo-captura.component';
import { BuscaContratosGridComponent } from './busca-contratos-grid/busca-contratos-grid.component';
import { GenerarOrdenTrabajoComponent } from './generar-orden-trabajo/generar-orden-trabajo.component';
import { OrdenesTrabajoComponent } from './ordenes-trabajo/ordenes-trabajo.component';
import { OrdenesTrabajoFlujoComponent } from './ordenes-trabajo-flujo/ordenes-trabajo-flujo.component';
import { HistoricoLecturasGridComponent } from './historico-lecturas-grid/historico-lecturas-grid.component';
import { CatReportesComponent } from './cat-reportes/cat-reportes.component';
import { CatParametrosGridComponent } from './cat-parametros-grid/cat-parametros-grid.component';
import { CargoDetallesGridComponent } from './cargo-detalles-grid/cargo-detalles-grid.component';
import { PadObservacionesGridComponent } from './pad-observaciones-grid/pad-observaciones-grid.component';
import { RemesasComponent } from './remesas/remesas.component';
import { CatCuentasContablesComponent } from './cat-cuentas-contables/cat-cuentas-contables.component';
import { CatTipoObservacionGridComponent } from './cat-tipo-observacion-grid/cat-tipo-observacion-grid.component';
import { DomiciliacionComponent } from './domiciliacion/domiciliacion.component';
import { FDomiciliacionGridComponent } from './fdomiciliacion-grid/fdomiciliacion-grid.component';
import { GenerarPolizasComponent } from './generar-polizas/generar-polizas.component';
import { CatTiieGridComponent } from './cat-tiie-grid/cat-tiie-grid.component';
import { EnvioMasivoReciboComponent } from './envio-masivo-recibo/envio-masivo-recibo.component';
import { CalculoCargosEspecialesGridComponent } from './calculo-cargos-especiales-grid/calculo-cargos-especiales-grid.component';
import { OpenseadragonViewerComponent } from '../openseadragon-viewer/openseadragon-viewer.component'; // import bn-ng-idle service
import { CatDelegacionesComponent } from './cat-delegaciones-grid/cat-delegaciones-grid.component';
import { FConsultaPagosSigeinGridComponent } from './fconsulta-pagos-sigein-grid/fconsulta-pagos-sigein-grid.component';
import { ReimprimeReciboAguaComponent } from './reimprime-recibo-agua/reimprime-recibo-agua.component';


@NgModule({
  declarations: [
    PersonaClientesComponent,
    AguaBuscaCuentasComponent, 
    AguasComponent,
    PersonasComponent,
    MedidoresComponent,
    CargosDetallesComponent,
    BuscaTramiteComponent,
    CatConceptosComponent,
    CertificadoNoAdeudoComponent,
    MonitoreoFlujoTramiteComponent,
    VisorComponent,
    BuscaDetalleSolicitudComponent,
    InfoTramiteComponent,
    CmpFacturacionComponent,
    MedioPagosComponent,
    CobrosAguaComponent,
    CajaServiciosComponent,
    CortesComponent,
    EstadoCuentaInformacionComponent,
    DatosCartowebComponent,
    CortesAperturaComponent,
    DatosFacturacionCajaComponent,
    CancelaCobrosComponent,
    ConsultaLecturasComponent,
    EjecucionFiscalInformacionComponent,
    GeneraRutasComponent,
    ConsumosRowComponent,
    ConsumosGridComponent,
    CatColoniasComponent,
    ObtenerUsuarioPorCargoComponent,
    CatMunicipiosComponent,
    CatMunicipiosGridComponent,
    VencimientosLecturaComponent,
    PadronAguaGeneralesComponent,
    CatDescuentosComponent,
    CatTipoServiciosGridComponent,
    CatAguaZonasGridComponent,
    CatGrupoConceptosGridComponent,
    CatDireccionesGridComponent,
    CatDepartamentosGridComponent,
    CatConceptosGridComponent,
    AguaBloqueosComponent,

    // CatTipoDocumentosComponent,
    CatAnomaliasGridComponent,
    CatUsuariosGridComponent,
    CatSucursalesGridComponent,
    CatCalendarioGridComponent,
    CatEstatusGridComponent,
    CatVencimientos_GridComponent,
    CatTipoTomasGridComponent,
    CatTipoDocumentosGridComponent,
    CatTipoIngresoGridComponent,
    CatTipoPeriodosGridComponent,
    CatTipoLevantamientosGridComponent,
    CatTipoPersonasGridComponent,
    CatUnidadMedidasGridComponent,
    CatUnidadCobrosGridComponent,
    CatUbicacionMedidoresGridComponent,
    CatAtributoInmueblesGridComponent,
    CatCategoriaAtributosGridComponent,
    CatCfdiUsosGridComponent,
    CatCargosGridComponent,
    CatConceptoCostosGridComponent,
    CatConsumoTarifasGridComponent,
    CatDiametroTomasGridComponent,
    CatEtapasTramitesGridComponent,
    CatFundamentosLegalesGridComponent,
    CatInpcsGridComponent,
    CatMarcaMedidoresGridComponent,
    CatMedioPagosGridComponent,
    CatMotivoLevantamientosGridComponent,
    CatParametroGruposGridComponent,
    CatRequisitosGridComponent,
    CatRolesGridComponent,
    CatTipoBloqueosGridComponent,
    CatTipoComprobantesGridComponent,
    CatTipoConsumosGridComponent,
    CatTipoContratoPersonasGridComponent,
    CatTipoGirosGridComponent,
    CatTipoMedidoresGridComponent,
    CatTipoUsosGridComponent,
    CatBancosGridComponent,
    CatEstadoFuncionamientosGridComponent,
    CatEstadosGridComponent,
    CatCallesGridComponent,
    CatMotivoCancelacionesGridComponent,
    AguaDescuentosComponent,
    EnviarCorreoComponent,
    SolicitudDetallesGridComponent,
    CatModulosGridComponent,
    CatNivelSeguridadesGridComponent,
    PrivilegiosGridComponent,
    MedidoresGridComponent,
    AguaBuscaCuentasGridComponent,

    BajaDeCuentaComponent,
    AltaMedidoresComponent,
    RConceptosEtapasTramitesGridComponent,
    EstadoCuentaComponent,
    ProrrateosComponent,
    EstadocuentamasivoComponent,
    VentanillaComponent,
    InformacionComponent,
    PrivilegiosARolesComponent,
    RUsuarioNivelesGridComponent,
    CapturaLecturaRutasComponent,
    CorrecionLecturasComponent,
    SimuladorLecturasComponent,
    RolesAUsuariosComponent,
    AguaBuscaCuentaOnlineComponent,
    EstadoCuentaOnlineComponent,
    EstadoCuentaInformacionOnlineComponent,
    CargosDetallesOnlineComponent,
    ManualesComponent,
    ConciliacionComponent,
    BuscaBitacoraGridComponent,
    ConsultaBitacoraGridComponent,
    EdicionCargoComponent,
    PrescripcionComponent,
    ConsultaHistoricoMigradoGridComponent,
    ConsultaHistoricoMovimientosGridComponent,
    EstadocuentamasivoCapturaComponent,
    BuscaContratosGridComponent,
    GenerarOrdenTrabajoComponent,
    OrdenesTrabajoComponent,
    OrdenesTrabajoFlujoComponent,
    HistoricoLecturasGridComponent,
    CatReportesComponent,
    CatParametrosGridComponent,
    CargoDetallesGridComponent,
    PadObservacionesGridComponent,
    RemesasComponent,
    CatCuentasContablesComponent,
    CatTipoObservacionGridComponent,
    DomiciliacionComponent,
    FDomiciliacionGridComponent,
    GenerarPolizasComponent,
    CatTiieGridComponent,
    EnvioMasivoReciboComponent,
    CalculoCargosEspecialesGridComponent,
    OpenseadragonViewerComponent,
    CatDelegacionesComponent,
    FConsultaPagosSigeinGridComponent,
    ReimprimeReciboAguaComponent
  ],
  imports: [
    NgxCurrencyModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ComponentesRoutingModule,
    // PdfViewerModule,
    //NgxExtendedPdfViewerModule,

    //<<PrimeNG>>
    DropdownModule,
    SliderModule,
    RadioButtonModule,
    DialogModule,
    InputTextModule,
    CardModule,
    ButtonModule,
    ListboxModule,
    PickListModule,
    VirtualScrollerModule,
    MenuModule,
    TableModule,
    MultiSelectModule,
    MenubarModule,
    TabViewModule,
    InputMaskModule,
    CheckboxModule,
    TooltipModule,
    ConfirmDialogModule,
    ProgressBarModule,
    InputSwitchModule,
    MessagesModule,
    TriStateCheckboxModule,
    CalendarModule,
    OverlayPanelModule,
    ScrollPanelModule,
    ToggleButtonModule,
    ToolbarModule,
    PanelModule,
    FileUploadModule,
    SelectButtonModule,
    GalleriaModule,
  ],
  exports: [
    PersonaClientesComponent,
    AguaBuscaCuentasComponent,
    AguasComponent,
    PersonasComponent,
    MedidoresComponent,
    CargosDetallesComponent,
    BuscaTramiteComponent,
    CatConceptosComponent,
    CertificadoNoAdeudoComponent,
    MonitoreoFlujoTramiteComponent,
    VisorComponent,
    BuscaDetalleSolicitudComponent,
    InfoTramiteComponent,
    CmpFacturacionComponent,
    MedioPagosComponent,
    CobrosAguaComponent,
    CajaServiciosComponent,
    CortesComponent,
    EstadoCuentaInformacionComponent,
    DatosCartowebComponent,
    CortesAperturaComponent,
    CancelaCobrosComponent,
    ConsultaLecturasComponent,
    EjecucionFiscalInformacionComponent,
    GeneraRutasComponent,
    CatColoniasComponent,
    SolicitudDetallesGridComponent,
    EnviarCorreoComponent,
    MedidoresGridComponent,
    MedidoresComponent,

    //---------------------- CATALOGOS GRID ---------------------------
    CatMunicipiosGridComponent,
    VencimientosLecturaComponent,
    PadronAguaGeneralesComponent,
    CatDescuentosComponent,
    CatTipoServiciosGridComponent,
    CatAguaZonasGridComponent,
    CatGrupoConceptosGridComponent,
    CatDireccionesGridComponent,
    CatDepartamentosGridComponent,
    CatConceptosGridComponent,
    CatAnomaliasGridComponent,
    CatUsuariosGridComponent,
    CatSucursalesGridComponent,
    CatCalendarioGridComponent,
    CatEstatusGridComponent,
    CatVencimientos_GridComponent,
    CatTipoTomasGridComponent,
    CatTipoDocumentosGridComponent,
    CatTipoIngresoGridComponent,
    CatTipoPeriodosGridComponent,
    CatTipoLevantamientosGridComponent,
    CatTipoPersonasGridComponent,
    CatTiieGridComponent,
    CatUnidadCobrosGridComponent,
    CatConceptosGridComponent,
    //   CatTipoDocumentosComponent
    CatUnidadMedidasGridComponent,
    CatUbicacionMedidoresGridComponent,
    CatAtributoInmueblesGridComponent,
    CatCategoriaAtributosGridComponent,
    CatCfdiUsosGridComponent,
    CatCargosGridComponent,
    CatConceptoCostosGridComponent,
    CatConsumoTarifasGridComponent,
    CatDiametroTomasGridComponent,
    CatEtapasTramitesGridComponent,
    CatFundamentosLegalesGridComponent,
    CatInpcsGridComponent,
    CatMarcaMedidoresGridComponent,
    CatMedioPagosGridComponent,
    CatMotivoLevantamientosGridComponent,
    CatParametroGruposGridComponent,
    CatRequisitosGridComponent,
    CatRolesGridComponent,
    CatTipoBloqueosGridComponent,
    CatTipoComprobantesGridComponent,
    CatTipoConsumosGridComponent,
    CatTipoContratoPersonasGridComponent,
    CatTipoGirosGridComponent,
    CatTipoMedidoresGridComponent,
    CatTipoUsosGridComponent,
    CatBancosGridComponent,
    CatEstadoFuncionamientosGridComponent,
    CatEstadosGridComponent,
    CatCallesGridComponent,
    CatMotivoCancelacionesGridComponent,
    AguaBloqueosComponent,
    AguaDescuentosComponent,
    CatModulosGridComponent,
    CatNivelSeguridadesGridComponent,
    PrivilegiosGridComponent,
    RConceptosEtapasTramitesGridComponent,
    EstadoCuentaComponent,
    ProrrateosComponent,
    EstadocuentamasivoComponent,
    VentanillaComponent,
    InformacionComponent,
    BajaDeCuentaComponent,
    PrivilegiosARolesComponent,
    RUsuarioNivelesGridComponent,
    RolesAUsuariosComponent,
    AguaBuscaCuentaOnlineComponent,
    EstadoCuentaOnlineComponent,
    EstadoCuentaInformacionOnlineComponent,
    CargosDetallesOnlineComponent,
    ManualesComponent,
    ConciliacionComponent,
    BuscaBitacoraGridComponent,
    ConsultaBitacoraGridComponent,
    BuscaContratosGridComponent,
    GenerarOrdenTrabajoComponent,
    OrdenesTrabajoComponent,
    OrdenesTrabajoFlujoComponent,
    HistoricoLecturasGridComponent,
    CatReportesComponent,
    CatParametrosGridComponent,
    RemesasComponent,
    CatCuentasContablesComponent,
    CatTipoObservacionGridComponent,
    GenerarPolizasComponent,
    EnvioMasivoReciboComponent,
    CatDelegacionesComponent,
  ],
  providers: [ConfirmationService, MessageService],
})
export class ComponentesModule {}
